import React from 'react'

import { ReactComponent as PersonIcon } from '../../../assets/icons/user-alt-vet.svg'
import { ReactComponent as StethoscopeIcon } from '../../../assets/icons/stethoscope.svg'
import { ReactComponent as SyringueIcon } from '../../../assets/icons/syringe-duotone.svg'
import { ReactComponent as MedicalIcon } from '../../../assets/icons/medical-duotone.svg'
import { ReactComponent as WaveformIcon } from '../../../assets/icons/waveform-duotone.svg'

export const SISTEM_ACTIONS = [
  {
    icon: <PersonIcon />,
    title: 'Cadastrar',
    subtitle: 'Cadastre um novo tutor ou pet',
    showModal: true,
    isEnabled: true
  },
  {
    icon: <StethoscopeIcon />,
    title: 'Consultar',
    subtitle: 'Inicie uma nova ficha de consulta',
    url: 'vets/tutores-e-pets?nova_consulta=true',
    isEnabled: true
  },
  {
    icon: <SyringueIcon />,
    title: 'Vacinar',
    subtitle: 'Registre aplicação de uma vacina',
    url: {},
    isEnabled: false
  },
  {
    icon: <MedicalIcon />,
    title: 'Receitar',
    subtitle: 'Crie uma nova prescrição',
    url: {},
    isEnabled: false
  },
  {
    icon: <WaveformIcon />,
    title: 'Solicitar',
    subtitle: 'Crie uma solicitação de exame',
    url: {},
    isEnabled: false
  }
]

export const tabs = [
  {
    title: 'Próximas'
  },
  {
    title: 'Vencidas'
  }
]
